import '../switch';

describe('switch', () => {
  it('Expect custom element <gsmlg-switch> is defined', () => {
    expect(customElements.get('gsmlg-switch')).toBeDefined();
  });
});
